<template>
<div >
	<Loader :show="saving"></Loader>

	<b-form @submit.prevent="save" v-if="!loading" novalidate >
		
		<b-form-group label="Nombre" >
			<b-form-input
				v-model="form.name"
				placeholder="Nombre"
				:state="!validation.hasError('form.name')" 
			></b-form-input>
			<b-form-invalid-feedback>Ingrese un nombre válido</b-form-invalid-feedback>
		</b-form-group>
		

		<b-form-group label="Email" class="mt-2">
			<b-form-input
				v-model="form.email"
				type="email"
				placeholder="Correo electrónico"
				:state="!validation.hasError('form.email')" 
			></b-form-input>
			<b-form-invalid-feedback>Ingrese un dirección de email válida</b-form-invalid-feedback>
		</b-form-group>
		
		<b-form-group label="Password" class="mt-2" v-if="action=='create'">
			<b-form-input
				v-model="form.password"
				type="password"
				placeholder="Contraseña"
				:state="!validation.hasError('form.password')" 
			></b-form-input>
			<b-form-invalid-feedback>Ingrese una contraseña de al menos 6 caracteres</b-form-invalid-feedback>
		</b-form-group>


		<phone-input  class="mt-2"
			label="Teléfono"
			placeholder="Teléfono"
			v-model="form.phone"
			@changed="checkValidation"
			:defaultCountry="form.phone.countryCode"
			:hasError="validation.hasError('form.phone.validated')"
		></phone-input>
		
		<b-form-checkbox
			class="mt-2"
			id="checkbox-1"
			v-model="form.is_admin"
			name="checkbox-1"
			>
			Permiso de Administrador
		</b-form-checkbox>
		
		<b-form-checkbox
			class="mt-2"
			id="checkbox-2"
			v-model="form.can_transfer"
			name="checkbox-2"
			>
			Permiso de traslados
		</b-form-checkbox>
	
		<div class="overflow-hidden mt-3">
			<b-button type="button" class="pull-left" size="sm" variant="secondary" @click="changePassword()">Cambiar contraseña</b-button>
			<b-button type="submit" class="pull-right" size="sm" variant="primary">Guardar cambios</b-button>
		</div>
		
		<b-button type="button" @click="deletePrompt" block v-if="action=='update'" variant="outline-danger" class="btn-delete mt-4">Suspender usuario</b-button>
		
	</b-form>
	
	<EmployeePasswordModal ref="employeePasswordChange"/>

</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import PhoneInput from '@/components/PhoneInput'

import EmployeePasswordModal from './EmployeePasswordModal'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;


export default {
	name: 'EmployeeForm',
	mixins:[mixins],
	props:['id'],
	components:{
		Loader,
		PhoneInput,
		EmployeePasswordModal
	},
	data () {
		return {
			action: 'create',
			form: {
				name: null,
				email: null,
				password: null,
				phone: {
					validated: false
				}
			},
			loading: true,
			saving: false,
		}
	},
	validators: {
		'form.name': function (value) {
			return Validator.value(value).required();
		},
		'form.password': function (value) {
			return Validator.custom( () => {
				if(this.action=='create'){
					if(value.length<6){
						return "ingrese una contraseña valida"
					}
				}
			})
		},
		'form.email': function (value) {
			return Validator.value(value).required().email();
		},
		'form.phone.validated': function (value) {
			return Validator.custom( () => {
				if(!value){
					return "ingrese un telefono valido"
				}
			})
		},	
	},
	beforeMount(){
		console.log('beforeMount')
		if(this.id > 0){
			this.action = 'update'
			this.load(this.id)
		}else{
			this.loading = false
			this.$emit('loaded')
		}
	},
	methods: {
		changePassword(){
			console.log(this.$refs)
			this.$refs.employeePasswordChange.open(this.id)
		},
		load(id){
			this.$apollo.query({
				query: gql`query ($id: ID!) {
					user (id: $id) {
						id
						name
						email
						is_admin
						can_transfer
						phone{
							countryCode
							national
							international
							type
							validated
						}
					}
				}`,
				variables: {
					id
				},
			})
			.then((data) => {
				this.form = data.data.user;
				this.loading = false
				this.$emit('loaded')
			});
		},
		checkValidation() {
			return this.$validate()
			.then(function (success) {
				if (success) {
					return true
				}
				return false
			});
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				
				let dataInput = {
					name 		: this.form.name,
					email 		: this.form.email,
					password	: this.form.password,
					phone 		: this.form.phone,
					is_admin 	: this.form.is_admin,
					can_transfer: this.form.can_transfer,
				}

				if(this.action == 'create' ){
					this.create(dataInput)
				}else
				if(this.action == 'update' ){
					this.update(this.form.id, dataInput)
				}
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data: UserInput! ){
					userCreate( data: $data) {
						id
					}
				}`,
				variables: {
					data
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados')
				this.$emit('updated')
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})

		},
		update (id, data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID!, $data: UserInput! ){
					userUpdate( id: $id, data: $data) {
						id
					}
				}`,
				variables: {
					id: id,
					data: data,
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados')
				this.$emit('updated')
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		},
		deletePrompt() {
			this.$dialog
			.confirm('¿Está seguro que desea suspender este funcionario?')
			.then(() => {
				this.delete()
			})
		},
		delete() {
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID! ){
					userDelete( id: $id) {
						id
					}
				}`,
				variables: {
					id: this.form.id,
				}
			})
			.then(() => {
				this.$toast.success('Elemento eliminado correctamente')
				this.$emit('updated')
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		}
	}
}


</script>
